export default __webpack_public_path__ + "static/media/DSC05820.0c332929.jpg";